// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"47":"8ae3e7f3e805246e95c4","160":"44c9d28b9f509dde58b8","384":"43443a1392f661152830","747":"a8ef08a173ce68dd1048","894":"5f3abf6763157a40bb17"}[chunkId] + ".js";
};